import React, { useState, useEffect } from 'react';
import { Modal, Button, Input, Select } from 'antd';
import { ModalBody, ModalContainer, InputLabel, Container, InputContainer } from './styles';
import NoTeam from '../NoTeam';
import Loader from '../Loader';
import { createNewFolder, updateFolder } from '../../utils/services/folderAPI';
import { getGroupPermission } from '../../utils/services/teamsAPI';
import { DESIGN_AREA_FOLDERS_TAB } from '../../containers/SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';

const { Option } = Select;
const NAMESPACES = ['DESIGN_AREA_FOLDERS_TAB'];

const CreateFolderModal = props => {
  const { visible, onCancel, target, isEditable, parentId, resourceGroup } = props;
  const { t } = useTranslation(NAMESPACES);
  const [folderName, setfolderName] = useState(target.name);
  const [isvalidName, setIsValidName] = useState(target.name ? true : false);
  const [isLoading, setLoading] = useState(false);
  const [allTeams, setAllTeams] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(
    String(resourceGroup || target.resourceGroup || ''),
  );
  const [noTeam, setnoTeam] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const teamData = await getGroupPermission(true);
    if (teamData?.data) {
      if (teamData.data.length === 1 && !isEditable && !parentId) {
        setSelectedGroup(teamData.data[0].rgId);
      }
      if (teamData.length === 0) {
        setnoTeam(true);
      }
      setAllTeams(teamData.data);
    } else {
      setnoTeam(true);
    }
    setPageLoading(false);
  };

  const addNewFolder = async () => {
    let response;
    let payload = {
      parentId,
      name: folderName.trim(),
      id: target.id,
      resourceGroup: selectedGroup,
    };
    setLoading(true);
    if (!isEditable) {
      response = await createNewFolder(payload);
    } else {
      response = await updateFolder(payload);
    }
    if (response) {
      setLoading(false);
      if (response && response.errors && response.errors.length === 0) {
        const responseType = isEditable ? 'folder updated successfully' : 'folder created successfully';
        onCancel(responseType, response.id, payload);
      }
    }
  };

  const handleChange = e => {
    const { value } = e.target;
    if (!value.replace(/\s/g, '').length) {
      setIsValidName(false);
    } else {
      setIsValidName(true);
    }
    setfolderName(value);
  };

  const handleKeyPress = e => {
    if (folderName && e.key === 'Enter') {
      addNewFolder();
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={
          isEditable
            ? t(DESIGN_AREA_FOLDERS_TAB.UPDATE_FOLDER_MODAL_TITLE.key, DESIGN_AREA_FOLDERS_TAB.UPDATE_FOLDER_MODAL_TITLE.value)
            : t(DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_FOLDER_MODAL_TITLE.key, DESIGN_AREA_FOLDERS_TAB.CREATE_NEW_FOLDER_MODAL_TITLE.value)
        }
        centered  
        maskClosable={false}
        visible={visible}
        onCancel={onCancel}
        footer={
          noTeam
            ? null
            : [
                <Button key="back" onClick={onCancel}>
                  {t(DESIGN_AREA_FOLDERS_TAB.CANCEL_DELETE_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.CANCEL_DELETE_FOLDER_BUTTON.value)}
                </Button>,
                <Button
                  key="Create Folder"
                  type="primary"
                  disabled={!folderName || !isvalidName || !selectedGroup}
                  loading={isLoading}
                  onClick={addNewFolder}
                >
                  {isEditable
                    ? isLoading
                      ? t(DESIGN_AREA_FOLDERS_TAB.UPDATING_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.UPDATING_FOLDER_BUTTON.value)
                      : t(DESIGN_AREA_FOLDERS_TAB.UPDATE_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.UPDATE_FOLDER_BUTTON.value)
                    : isLoading
                    ? t(DESIGN_AREA_FOLDERS_TAB.CREATING_NEW_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.CREATING_NEW_FOLDER_BUTTON.value)
                    : t(DESIGN_AREA_FOLDERS_TAB.CREATE_FOLDER_BUTTON.key, DESIGN_AREA_FOLDERS_TAB.CREATE_FOLDER_BUTTON.value)}
                </Button>,
              ]
        }
      >
        <ModalBody>
          <ModalContainer>
            {pageLoading ? (
              <Loader />
            ) : noTeam ? (
              <NoTeam type="folder" />
            ) : (
              <>
                <InputContainer className="full-width">
                  <InputLabel>{t(DESIGN_AREA_FOLDERS_TAB.FOLDER_NAME_LABEL.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_NAME_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(DESIGN_AREA_FOLDERS_TAB.FOLDER_NAME_PLACEHOLDER.key, DESIGN_AREA_FOLDERS_TAB.FOLDER_NAME_PLACEHOLDER.value)}
                    name="folder"
                    value={folderName}
                    onChange={handleChange}
                    autoComplete={"off"}
                  />
                </InputContainer>
                {allTeams.length > 1 && !parentId && (
                  <InputContainer>
                    <InputLabel>{t(DESIGN_AREA_FOLDERS_TAB.SELECT_TEAM_LABEL.key, DESIGN_AREA_FOLDERS_TAB.SELECT_TEAM_LABEL.value)}</InputLabel>
                    <Select
                      loading={!allTeams}
                      showSearch
                      placeholder={t(DESIGN_AREA_FOLDERS_TAB.SELECT_TEAM_PLACEHOLDER.key, DESIGN_AREA_FOLDERS_TAB.SELECT_TEAM_PLACEHOLDER.value)}
                      optionFilterProp="children"
                      value={selectedGroup || undefined}
                      onChange={value => setSelectedGroup(value)}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {allTeams &&
                        allTeams.map(data => {
                          return (
                            <Option key={String(data.id)} value={data.rgId}>
                              {data.groupName}
                            </Option>
                          );
                        })}
                    </Select>
                  </InputContainer>
                )}
              </>
            )}
          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default CreateFolderModal;
